import { Toast, ToastTitle, VStack } from '@gluestack-ui/themed'
import React from 'react'
import { i18n } from '../../lib/i18n'
import { theme } from '../../theme'

type ToastPlacement = 'top' | 'bottom' | 'top right' | 'top left' | 'bottom right' | 'bottom left'
type ToastFunction = (config: { placement: ToastPlacement; duration: number; render: () => React.ReactNode }) => void

class ToastManager {
  private toastShow: ToastFunction | null = null

  setToast(toastShow: ToastFunction) {
    this.toastShow = toastShow
  }

  showDanger(message: string = i18n.t('toast.error'), duration = 1500) {
    if (!this.toastShow) return
    this.toastShow({
      placement: 'top',
      duration,
      render: (): React.ReactNode => (
        <Toast action="error" style={{ backgroundColor: theme.colors.red }}>
          <VStack>
            <ToastTitle style={{ color: theme.colors.white }}>{message}</ToastTitle>
          </VStack>
        </Toast>
      ),
    })
  }

  showSuccess(message: string = i18n.t('toast.success'), placement: 'top' | 'bottom' = 'top', duration = 2000) {
    if (!this.toastShow) return
    this.toastShow({
      placement,
      duration,
      render: (): React.ReactNode => (
        <Toast action="success" style={{ backgroundColor: theme.colors.green }}>
          <VStack>
            <ToastTitle style={{ color: theme.colors.white }}>{message}</ToastTitle>
          </VStack>
        </Toast>
      ),
    })
  }

  showWarning(message: string, placement: 'top' | 'bottom' = 'top', duration = 3000) {
    if (!this.toastShow) return
    this.toastShow({
      placement,
      duration,
      render: (): React.ReactNode => (
        <Toast action="warning" style={{ backgroundColor: theme.colors.orange }}>
          <VStack>
            <ToastTitle style={{ color: theme.colors.white }}>{message}</ToastTitle>
          </VStack>
        </Toast>
      ),
    })
  }
}

export const toastManager = new ToastManager()

export const showDanger = (message?: string, duration?: number) => toastManager.showDanger(message, duration)
export const showSuccess = (message?: string, placement?: 'top' | 'bottom', duration?: number) => toastManager.showSuccess(message, placement, duration)
export const showWarning = (message: string, placement?: 'top' | 'bottom', duration?: number) => toastManager.showWarning(message, placement, duration)
